import { render } from "./Home.vue?vue&type=template&id=a1354374&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=a1354374&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a1354374"

export default script